import React from "react";
import { Checkbox } from "../ui/checkbox";
import { formatCurrencyBRL, getTipoAceiteLabel, getTipoAceiteClass } from "../../lib/utils";

export function CustomProcessCard({
  process,
  isSelected,
  onToggle,
  hideCheckbox = false,
}) {
  const valorCredito = Number(process.valor_proposta_final || 0);
  const valorFgts = Number(process.valor_fgts || 0);
  const cnj = process.processo?.cnj || process.cnj || "";
  const nomeProcesso = process.processo?.nome_processo || process.nome_processo || "";
  const descricao = process.processo?.descricao || null;
  const exibirFgts = process.processo?.exibir_fgts === true && valorFgts > 0;

  const processoLabel =
    cnj && nomeProcesso
      ? `${cnj} — ${nomeProcesso}`
      : nomeProcesso || cnj || "N/A";

  return (
    <div
      className={`bg-white rounded-2xl border transition-all duration-200 overflow-hidden ${
        !hideCheckbox && isSelected
          ? "border-primary shadow-md shadow-primary/10"
          : "border-border shadow-sm hover:shadow-md hover:border-border"
      }`}
    >
      {/* Header row */}
      <div className="px-4 pt-4 pb-3 flex items-start justify-between gap-3">
        <div className="flex items-start gap-3 min-w-0">
          {!hideCheckbox && (
            <Checkbox
              id={`process-${process.id}`}
              checked={isSelected}
              onCheckedChange={(checked) => onToggle && onToggle(process.id, checked)}
              className="mt-0.5 shrink-0"
            />
          )}
          <div className="min-w-0">
            <p className="text-[10px] font-bold uppercase tracking-widest text-muted-foreground mb-0.5">
              Processo
            </p>
            <label
              htmlFor={`process-${process.id}`}
              className="text-sm font-semibold text-foreground leading-snug line-clamp-2 cursor-pointer"
            >
              {processoLabel}
            </label>
          </div>
        </div>

        {process.tipo_aceite && (
          <span className={`text-xs font-semibold px-2.5 py-1 rounded-full shrink-0 ${getTipoAceiteClass(process.tipo_aceite)}`}>
            {process.tipo_aceite === "acordo"
              ? (process.processo?.label_tipo_aceite_acordo || getTipoAceiteLabel(process.tipo_aceite))
              : process.tipo_aceite === "cessao"
                ? (process.processo?.label_tipo_aceite_cessao || getTipoAceiteLabel(process.tipo_aceite))
                : getTipoAceiteLabel(process.tipo_aceite)}
          </span>
        )}
      </div>

      {/* Value block */}
      <div className="px-4 pb-4 space-y-2">
        <div className="bg-muted rounded-xl px-4 py-3.5">
          <p className="text-xs font-medium text-muted-foreground mb-1">Valor estimado a receber</p>
          <p className="text-2xl sm:text-3xl font-black text-foreground tracking-tight leading-none">
            <span className="font-mono tabular-nums">{formatCurrencyBRL(valorCredito)}</span>
          </p>
          {descricao && (
            <p className="text-xs text-muted-foreground mt-2 leading-snug">{descricao}</p>
          )}
        </div>

        {exibirFgts && (
          <div className="flex items-center gap-2.5 bg-statusWarningBg border border-amber-100 rounded-xl px-3.5 py-2.5">
            <div className="w-2 h-2 rounded-full bg-amber-400 shrink-0" />
            <p className="text-xs font-semibold text-statusWarning leading-snug">
              <span className="font-black">{formatCurrencyBRL(valorFgts)}</span> a serem pagos via conta vinculada (FGTS)
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
